import { useParams } from 'react-router-dom';

import { USER_TYPES } from 'shared_DEPRECATED/types/User';
import { routeNames } from 'shared_DEPRECATED/utils/config';

import { useUserMode } from 'features/user/hooks';

export const useGoalsNavigationLink = (participantEmail?: string) => {
  const { email } = useParams();
  const userMode = useUserMode();

  const resolvedEmail = participantEmail || email;

  const userSpecificRoute =
    userMode === USER_TYPES.USER ? '' : `/hde/participants/${resolvedEmail}`;

  return `${userSpecificRoute}/${routeNames.GOALS}`;
};
